import { render, staticRenderFns } from "./AvailabilityLegend.vue?vue&type=template&id=331239f8&scoped=true"
import script from "./AvailabilityLegend.vue?vue&type=script&lang=js"
export * from "./AvailabilityLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331239f8",
  null
  
)

export default component.exports